import { PopUpFocusProps } from '@/types/game';
import classNames from './PopUpFocus.module.scss';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import classes from 'classnames';
import { useState } from 'react';
import UseScreenSize from '@/hooks/UseScreenSize';
import { useAppSelector } from '@/store';
import { interfaceLanguageSelector } from '@/store/reducers/auth';

import QuizTip from '../QuizTip/QuizTip';
import TheButton from '@/components/TheButton/TheButton';

import target from '@/assets/images/target.png';
import close from '@/assets/svg/close.svg';

const PopUpFocus = ({
  tip,
  className,
  inCorrectAnswers,
  totalQuestions,
  emitOnClosePopUp,
}: PopUpFocusProps) => {
  const { t } = useTranslation();
  const { isMobile, isDesktop } = UseScreenSize();
  const interfaceLanguage = useAppSelector(interfaceLanguageSelector);

  const [shouldExpand, setShouldExpand] = useState(false);

  const onExpand = () => {
    if (isDesktop) {
      return;
    }
    setShouldExpand(true);
  };

  const onReduce = () => {
    setShouldExpand(false);
  };

  const space = ' ';

  const titleElement = <h3>{t('focus')}</h3>;

  const descriptionElement = (
    <div className={classNames.text}>
      <div className={classNames.partOne}>
        <span className={classNames.oneMoreMistake}>{t('oneMoreMistake')}</span>
      </div>
      <span>{t('coinsWillBeLost')}</span>
    </div>
  );

  const imgElement = (
    <div className={classNames.target}>
      <img src={target} alt='target' />
    </div>
  );

  const questionsTextElement = (
    <div className={classNames.questions}>
      <div>
        <span className={classNames.amount}>
          {inCorrectAnswers + space}
          {t('outOf') + space}
          {totalQuestions + space}
        </span>
        <span>{t('questions')}</span>
      </div>
      <span>{t('answeredIncorrectly')}</span>
    </div>
  );

  return (
    <div className={classes(classNames.popUpFocus, className)}>
      {shouldExpand && isMobile && <div className={classNames.backdrop}></div>}
      {isDesktop && (
        <div className={classNames.desktopContent}>
          {imgElement}
          <div className={classNames.content}>
            {titleElement}
            {questionsTextElement}
            {descriptionElement}
          </div>
        </div>
      )}
      {isMobile && (
        <>
          {questionsTextElement}
          {titleElement}
          {imgElement}
          {descriptionElement}
        </>
      )}
      <div
        className={classes(classNames.bottom, {
          [classNames.expanded]: shouldExpand,
          [classNames.bottomNoTip]: !tip,
        })}
      >
        {shouldExpand && (
          <div className={classNames.close} onClick={onReduce}>
            <SVG src={close} />
          </div>
        )}
        <div
          className={classes(classNames.tipAndButton, {
            [classNames.tipAndButtonMobile]: isMobile,
          })}
        >
          {tip && (
            <QuizTip
              tip={tip ?? ''}
              className={classNames.tip}
              lampClassName={classes(
                classNames.lamp,
                classNames[`lamp-${interfaceLanguage?.direction}`]
              )}
              shouldExpand={shouldExpand}
              emitOnExpand={onExpand}
            />
          )}
          <TheButton
            className={classNames.button}
            text={isDesktop ? t('continueQuiz') : t('okLetsGo')}
            emitOnClick={() => emitOnClosePopUp?.()}
            showArrow={true}
          />
        </div>
      </div>
    </div>
  );
};

export default PopUpFocus;
